<!--
  Created 10.10.2023
  Transportation component for the proposal show page.
-->
<template>
  <ProposalSection
    section="transport"
    :content-editable="contentEditable"
    template-style="aqua"
    contents-class="!space-y-8">
    <template #content>
      <TextEditableTextarea
        v-if="contentEditable"
        id="transport-ingress"
        v-model="transport.ingress"
        background-style="gray"
        class=""
        :text-area-class="'bg-transparent whitespace-pre-wrap md:leading-snug lg:leading-tight text-gray-600 text-md lg:text-lg ' +
          'placeholder:italic placeholder:text-gray-500 placeholder:opacity-50 cursor-text'"
        :placeholder="'Fill in transport ingress..'"
        :show-buttons="false"
        :saved-changes="savedChanges"
        @edited="store.unsavedChanges.changes.proposal = true;" />
      <div
        v-else-if="!store.printMode"
        class="whitespace-pre-wrap text-gray-600 md:leading-snug lg:space-y-2 lg:text-lg lg:leading-tight">
        {{ transport.ingress }}
      </div>

      <div v-if="transport.items.filter((filterItem) => (filterItem.heading || filterItem.outbound.date)) < 1 && !contentEditable">
        <p class="text-lg italic text-gray-500">
          Det er ikke lagt inn noe transport i programmet.
        </p>
      </div>

      <TransportCards
        :content-editable="contentEditable"
        :transport="transport.items"
        @add-item="addItem()"
        @remove-item="(index) => removeItem(index)" />

    </template>
  </ProposalSection>
</template>
<script setup>
/* external */
import { computed } from 'vue';
/* local */
import ProposalSection from '@/Pages/Proposal/Components/ProposalSection.vue';
import { useProposalStore } from '@/Stores/Proposal';
import TransportCards from '@/Pages/Proposal/Components/TransportCards.vue';
import { uniqueId } from '@/utils';
import TextEditableTextarea from '@/Components/Forms/TextEditableTextarea.vue';

/* *********************************************************************
 * Component declarations
 * ****************************************************************** */

defineProps({
  contentEditable: {
    type: Boolean,
    default: false,
  },
});

const store = useProposalStore();
const transport = computed(() => store.proposal.data.transport);
const savedChanges = computed(() => !store.unsavedChanges.changes.proposal);

/* *********************************************************************
 * Component functions
 * ****************************************************************** */

/**
 * Add a new item to the transport array.
 */
function addItem() {
  transport.value.items.push(
    {
      id: uniqueId(),
      heading: '',
      outbound: {
        overline: '',
        date: '',
        departureText: '',
        arrivalText: '',
      },
      inbound: {
        overline: '',
        date: '',
        departureText: '',
        arrivalText: '',
      },
    },
  );
  store.unsavedChanges.changes.proposal = true;
}

/**
 * Remove an item from the transport array.
 * @param {number} index - The index of the item to remove
 */
function removeItem(index) {
  transport.value.items.splice(index, 1);
  store.unsavedChanges.changes.proposal = true;
}

/* *********************************************************************
 * Page lifecycle functions
 * ****************************************************************** */

</script>
